import { Default } from './Default'

export const Loaders = { Default }
